import { get } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const cnpjUrl = url.CONSULT_CNPJ_API;
const cepUrl = url.CONSULT_CEP_API;

export const getCnpj = (data) => get(`${cnpjUrl}${data}`);
export const getCep = (data) => get(`${cepUrl}${data}`);
